import { SVGPropsIcon } from 'src/types';

export const LinkIcon = (props: SVGPropsIcon) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g clip-path="url(#clip0_29718_8706)">
      <path
        d="M10.9321 5.86914L9.18055 7.6207C8.89763 7.90361 8.70554 8.24348 8.6042 8.60375C9.36659 8.38932 10.2203 8.58142 10.819 9.18016C11.4177 9.7789 11.6098 10.6326 11.3954 11.3949C11.294 11.7552 11.1019 12.095 10.819 12.378L9.06727 14.1298L6.7965 16.4006C5.9149 17.2822 4.48035 17.2822 3.59869 16.4006C2.71709 15.5189 2.71709 14.0844 3.59869 13.2028L5.86946 10.932C5.35278 9.44272 5.53171 7.76342 6.4059 6.4054C6.10007 6.60232 5.81045 6.83444 5.543 7.1019L1.52067 11.1242C-0.50692 13.1518 -0.506861 16.4509 1.52067 18.4785C3.54821 20.5061 6.84735 20.5061 8.87494 18.4785L12.8973 14.4562C13.1647 14.1887 13.3969 13.8992 13.5938 13.5933C14.468 12.2353 14.6467 10.5563 14.13 9.06695C13.8809 8.3487 13.4699 7.67454 12.8973 7.1019C12.3245 6.52925 11.6503 6.11831 10.9321 5.86914Z"
        fill="#FFE100"
      />
      <path
        d="M10.8189 9.18145C11.4176 9.7802 11.6097 10.6339 11.3953 11.3963C11.294 11.7565 11.1019 12.0963 10.8189 12.3793L9.06739 14.1308L6.79662 16.4016C5.91502 17.2832 4.48047 17.2832 3.59881 16.4016C3.5847 16.3875 3.57001 16.3724 3.55631 16.358L1.48022 18.439C1.49416 18.4533 1.50644 18.4657 1.52061 18.4798C3.5482 20.5074 6.84729 20.5074 8.87488 18.4798L12.8972 14.4575C13.1647 14.19 13.3968 13.9004 13.5937 13.5946C14.4679 12.2366 14.6467 10.5572 14.1301 9.06797C13.8809 8.34972 13.47 7.67562 12.8973 7.10292L10.8189 9.18145Z"
        fill="#FDBE12"
      />
      <path
        d="M11.1247 1.52069L7.10234 5.54302C6.83489 5.81048 6.60276 6.0995 6.4059 6.4054C5.53171 7.76342 5.35278 9.44272 5.86946 10.932C6.11863 11.6502 6.52957 12.3243 7.10222 12.897C7.67492 13.4698 8.34914 13.8816 9.06739 14.1308L10.819 12.378C11.1019 12.095 11.294 11.7552 11.3954 11.3949C10.633 11.6093 9.77923 11.4178 9.18055 10.819C8.58181 10.2203 8.38977 9.36608 8.6042 8.60375C8.70554 8.24348 8.89763 7.90361 9.18055 7.6207L10.9321 5.86914L13.2031 3.59939C14.0847 2.71774 15.5192 2.71774 16.4009 3.59939C17.2825 4.48105 17.2825 5.9156 16.4009 6.7972L14.13 9.06695C14.6467 10.5562 14.4679 12.2366 13.5937 13.5946C13.8995 13.3976 14.189 13.1647 14.4565 12.8973L18.4788 8.87497C20.5064 6.84737 20.5064 3.54829 18.4788 1.52069C16.4513 -0.506898 13.1523 -0.506898 11.1247 1.52069Z"
        fill="white"
      />
      <path
        d="M7.10222 12.897C7.67486 13.4697 8.34902 13.8806 9.06727 14.1298L10.8189 12.3793C11.1019 12.0963 11.294 11.7565 11.3953 11.3963C10.6329 11.6107 9.77923 11.4178 9.18055 10.819L7.10222 12.897Z"
        fill="#E9EDF5"
      />
      <path
        d="M16.4009 3.59939C17.2825 4.48105 17.2825 5.9156 16.4009 6.7972L14.1301 9.06797C14.6468 10.5572 14.468 12.2353 13.5938 13.5933C13.8996 13.3963 14.189 13.1647 14.4565 12.8973L18.4788 8.87497C20.5064 6.84737 20.5064 3.54829 18.4788 1.52069L16.4009 3.59939Z"
        fill="#E9EDF5"
      />
    </g>
    <defs>
      <clipPath id="clip0_29718_8706">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
